<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>产品管理</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button class="qinang-button-margin" icon="money-collect" @click="priceManage()">价格管理</a-button>
				<a-button icon="sync" @click="apiProductQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="产品查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">所属服务商：</div>
						<a-select v-model="query.facilitatorId" style="width: 100%;">
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">产品名称：</div>
						<a-input v-model="query.productName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiProductQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						<span v-if="query.facilitatorId !== ''">[{{mainNavigation[0].facilitatorName}}]</span>
						产品列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="productId" :loading="tableLoading" :pagination="false">
	
				<span slot="productName" slot-scope="productName">
					<a-button type="link" @click="edit(productName)" >{{productName.productName}}</a-button>
				</span>
				
				<span slot="productClass" slot-scope="productClass">
					<span v-if="productClass == 2">门票</span>
					<span v-if="productClass == 3">剧院票</span>
				</span>
				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" @click="priceManage(tableAction)" >价格管理</a-button>
				</span>
				<span slot="productState" slot-scope="productState">
					<span v-if="productState == 2">禁用</span>
					<span v-if="productState == 3">启用</span>
				</span>
				<span slot="outType" slot-scope="outType">
					<span v-if="outType == 2">现场打印</span>
					<span v-if="outType == 3">现场激活</span>
					<span v-if="outType == 4">身份证出票</span>
				</span>
				<span slot="mediumClass" slot-scope="mediumClass">
					<span v-if="mediumClass == 2">一维条码</span>
					<span v-if="mediumClass == 3">二维条码</span>
					<span v-if="mediumClass == 4">感应卡</span>
				</span>
				
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal class="qa-modal" title="添加" width="100%" :visible="addVisible"  @cancel="addHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<div class="qa-table-item-3">
						<a-form-model-item label="服务商名称" has-feedback prop="facilitatorId">
							<a-select v-model="addForm.facilitatorId" style="width: 100%;">
								<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-2">
						<a-form-model-item label="产品名称" has-feedback prop="productName">
							<a-input v-model="addForm.productName" placeholder="请输入产品名称" />
						</a-form-model-item>
						<a-form-model-item label="产品编码" has-feedback prop="productCode">
							<a-input v-model="addForm.productCode" placeholder="6位以内数字或字母" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="产品类别" has-feedback prop="productClass">
							<a-select v-model="addForm.productClass">
								<a-select-option value="2">门票</a-select-option>
								<a-select-option value="3">剧院票</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="介质类型" has-feedback prop="mediumClass">
							<a-select v-model="addForm.mediumClass">
								<a-select-option value="2">一维条码</a-select-option>
								<a-select-option value="3">二维条码</a-select-option>
								<a-select-option value="4">感应卡</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="是否启用" has-feedback prop="productState">
							<a-radio-group name="productState" v-model="addForm.productState">
								<a-radio value="3">是</a-radio>
								<a-radio value="2">否</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
				
					<div class="qa-table-item-3">
						<a-form-model-item label="检票方式" has-feedback prop="checkType">
							<a-select v-model="addForm.checkType">
								<a-select-option value="2">一票一人</a-select-option>
								<a-select-option value="3">一票多人</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="使用方式" has-feedback prop="useType">
							<a-select v-model="addForm.useType">
								<a-select-option :value="2">次卡</a-select-option>
								<a-select-option :value="3">周卡</a-select-option>
								<a-select-option :value="4">月卡</a-select-option>
								<a-select-option :value="5">两月卡</a-select-option>
								<a-select-option :value="6">季卡</a-select-option>
								<a-select-option :value="7">半年卡</a-select-option>
								<a-select-option :value="8">年卡</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="出票方式" has-feedback prop="outType">
							<a-select v-model="addForm.outType">
								<a-select-option value="2">现场打印</a-select-option>
								<a-select-option value="3">现场激活</a-select-option>
								<a-select-option value="4">身份证出票</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="备注" has-feedback prop="remarks">
							<a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.remarks" />
						</a-form-model-item>
					</div>
					
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="addVisible = false">返回</a-button>
						<a-button type="primary" @click="addHandleOk">保存</a-button>
					</div>
				</a-form-model>
			</div>
			
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal class="qa-modal" title="修改" width="100%" :visible="editVisible"  @cancel="editHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<div class="qa-table-item-3">
						<a-form-model-item label="服务商名称" has-feedback prop="facilitatorId">
							<a-select v-model="editForm.facilitatorId" style="width: 100%;">
								<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-2">
						<a-form-model-item label="产品名称" has-feedback prop="productName">
							<a-input v-model="editForm.productName" placeholder="请输入产品名称" />
						</a-form-model-item>
						<a-form-model-item label="产品编码" has-feedback prop="productCode">
							<a-input v-model="editForm.productCode" placeholder="6位以内数字或字母" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="产品类别" has-feedback prop="productClass">
							<a-select v-model="editForm.productClass">
								<a-select-option :value="2">门票</a-select-option>
								<a-select-option :value="3">剧院票</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="介质类型" has-feedback prop="mediumClass">
							<a-select v-model="editForm.mediumClass">
								<a-select-option :value="2">一维条码</a-select-option>
								<a-select-option :value="3">二维条码</a-select-option>
								<a-select-option :value="4">感应卡</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="是否启用" has-feedback prop="productState">
							<a-radio-group name="productState" v-model="editForm.productState">
								<a-radio :value="3">是</a-radio>
								<a-radio :value="2">否</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
									
					<div class="qa-table-item-3">
						<a-form-model-item label="检票方式" has-feedback prop="checkType">
							<a-select v-model="editForm.checkType">
								<a-select-option :value="2">一票一人</a-select-option>
								<a-select-option :value="3">一票多人</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="使用方式" has-feedback prop="useType">
							<a-select v-model="editForm.useType">
								<a-select-option :value="2">次卡</a-select-option>
								<a-select-option :value="3">周卡</a-select-option>
								<a-select-option :value="4">月卡</a-select-option>
								<a-select-option :value="5">两月卡</a-select-option>
								<a-select-option :value="6">季卡</a-select-option>
								<a-select-option :value="7">半年卡</a-select-option>
								<a-select-option :value="8">年卡</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="出票方式" has-feedback prop="outType">
							<a-select v-model="editForm.outType">
								<a-select-option :value="2">现场打印</a-select-option>
								<a-select-option :value="3">现场激活</a-select-option>
								<a-select-option :value="4">身份证出票</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="备注" has-feedback prop="remarks">
							<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remarks" />
						</a-form-model-item>
					</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="editVisible = false">返回</a-button>
						<a-button type="primary" @click="editHandleOk">保存</a-button>
					</div>
					
				</a-form-model>
			</div>
			
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				facilitatorList: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: '',
					productName: '',
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [{
						title: 'ID',
						dataIndex: 'productId',
						key: 'productId',
						align: 'center'
					},
					{
						title: '产品名称',
						key: 'productName',
						align: 'center',
						scopedSlots: {
							customRender: 'productName'
						}
					},
					{
						title: '类别',
						dataIndex: 'productClass',
						key: 'productClass',
						align: 'center',
						scopedSlots: {
							customRender: 'productClass'
						}
					},
					{
						title: '操作',
						key: 'tableAction',
						align: 'center',
						scopedSlots: {
							customRender: 'tableAction'
						}
					},
					{
						title: '出票方式',
						dataIndex: 'outType',
						key: 'outType',
						align: 'center',
						scopedSlots: {
							customRender: 'outType'
						}
					},
					{
						title: '介质类型',
						dataIndex: 'mediumClass',
						key: 'mediumClass',
						align: 'center',
						scopedSlots: {
							customRender: 'mediumClass'
						}
					},
					{
						title: '状态',
						dataIndex: 'productState',
						key: 'productState',
						align: 'center',
						scopedSlots: {
							customRender: 'productState'
						}
					},
	

				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					facilitatorId: '',
					productName: '',
					productCode: '',
					productClass: '2',
					checkType: '2',
					useType: '2',
					outType: '2',
					mediumClass: '3',
					productState: '3',
					remarks: '',
					
				},
				addRules: {
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'blur' }],
					productName: [{ required: true, message: '产品名称不能为空', trigger: 'blur' }],
					productCode: [{ required: true, message: '产品编码不能为空', trigger: 'blur' }],
					productClass: [{ required: true, message: '请选择', trigger: 'blur' }],
					mediumClass: [{ required: true, message: '请选择', trigger: 'blur' }],
					productState: [{ required: true, message: '请选择', trigger: 'blur' }],
					checkType: [{ required: true, message: '请选择', trigger: 'blur' }],
					useType: [{ required: true, message: '请选择', trigger: 'blur' }],
					outType: [{ required: true, message: '请选择', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					productId: '',
					facilitatorId: '',
					productName: '',
					productCode: '',
					productClass: 2,
					checkType: 2,
					useType: 2,
					outType: 2,
					mediumClass: 2,
					productState: 2,
					remarks: '',
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//价格管理
			priceManage(e){
				if(e == undefined){
					if(!this.tableSelectedRows.productId) {
						this.$message.warning('请选择要修改的数据');
						return
					}
					e = this.tableSelectedRows
				}
				let priceManageMain = []
				priceManageMain[0] = {'facilitatorId': this.mainNavigation[0].facilitatorId, 'facilitatorName': this.mainNavigation[0].facilitatorName}
				priceManageMain[1] = {'productId': e.productId, 'productName': e.productName}
				window.sessionStorage.setItem("priceManageMain", JSON.stringify(priceManageMain))
				this.$router.push('/PriceManage')
			},
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,{staffId:window.sessionStorage.getItem('staffId'),facilitatorType:1});
				if (res.code == 200) {
					this.facilitatorList = res.data
					//判断是否是返回的页面
					let priceManageMain = JSON.parse(window.sessionStorage.getItem('priceManageMain'))
					if(priceManageMain == null) {
						this.query.facilitatorId = res.data[0].facilitatorId
					}else {
						this.query.facilitatorId = priceManageMain[0].facilitatorId
					}
					
					this.mainNavigation[0] = res.data[0]
					this.apiProductQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			//表格开始-搜索
			async apiProductQueryList() {
				this.tableLoading = true
				for(let i=0;i<this.facilitatorList.length;i++){
					if(this.facilitatorList[i].facilitatorId == this.query.facilitatorId) {
						this.mainNavigation[0] = this.facilitatorList[i]
					}
				}
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiProductQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiProductQueryList()
			},
			tableAdd() {
				this.addVisible = true
			},
			async apiProductAdd() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiProductQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiProductAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			addHandleCancel() {
				this.addVisible = false
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				this.editForm = items
				this.editVisible = true
			},
			async apiProductEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiProductQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiProductEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.productId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.departmentName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiProductDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiProductDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductDel, {productId: this.tableSelectedRows.productId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiProductQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				if(this.tableSelectedRows.productId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiFacilitatorList()
		}
	};
</script>

<style scoped>
	
</style>
